module.exports = __webpack_public_path__ + "static/media/6.a2e7ac07.png";